<template>
    <section class="p-4">
        <div class="flex justify-end md:justify-start">
            <div class="flex">
                <p class="mt-2 text-blue-700">Search:</p>
                <input class=" border-2 ml-3 p-2 rounded-lg" type="text" name="search" id="search" placeholder="search name, email" v-model="searchQuery">
            </div>
        </div>

        <div class="mt-6 text-sm md:overflow-x-auto">
            <table class="w-full">
                <p class="text-red-500">{{error}}</p>
                <thead>
                    <tr class="border-b">
                        <td>Name</td>
                        <td>Email</td>
                        <td>Phone Number</td>
                        <td>Date</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="admin in filterName" :key="admin.id" class="text-sm border-b">
                        <td class=" p-2">{{admin.firstName}} {{admin.lastName}}</td>
                        <td class=" text-blue-700">{{admin.email}}</td>
                        <td>{{admin.phone}}</td>
                        <td> {{moment(admin.updatedAt).format("DD/MM/YYYY")}} 
                            <span @click="toggleList(admin)" class=" fa fa-ellipsis-v ml-3 text-gray-500 cursor-pointer"></span>
                            <div class=" relative">
                                <ul class="absolute  text-xs bg-gray-50 pb-4 pl-2 pr-2" v-show="admin.navList">
                                    <li  @click="deleteAdminModal(admin)" class="border-b-2 cursor-pointer">Delete Admin</li>
                                </ul>
                            </div>
                            <!-- <div class=" relative">
                                <ul class="absolute right-5 text-xs bg-gray-50 pt-4 pb-4 pl-2 pr-2" v-show="admin.navList">
                                    <router-link :to="{name: 'admin-info', params : {id:admin.email}}">
                                        <li class="border-b-2 cursor-pointer">View Information</li>
                                    </router-link>
                                </ul>
                            </div> -->
                        </td>
                        
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="flex justify-between mt-10 text-gray-500 md:flex-col">
            <div>
                <p>Showing 1-{{currentList}} of {{totalList}} Admins </p>
            </div>

            <div class="flex">
                <button @click="prev" class="border w-24 text-center text-blue-600  border-blue-600"> <i class="fa fa-angle-left mr-2"></i>Previous </button>
                <button @click="next" class="border w-24 text-center border-blue-600 text-blue-600 ml-1">Next <i class="fa fa-angle-right ml-2"></i></button>
            </div>
        </div>
        <div>
            <DeleteModal
            v-show="deleteModal"
            @close="closeModal"
            :message="message"
            @getAdmin="getAdmin"
            :adminId="adminId"
            />
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import DeleteModal from './DeleteModal.vue'
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    components:{DeleteModal},
    data() {
        return {
            searchQuery: "",
            navList: null,
            adminList: [],
            page: 1,
            currentList: "",
            totalList: "",
            error: "",
            adminId : "",
            deleteModal : false,
            message: ""
        }
    },

    mounted() {
        this.getAdmin();
    },
    computed: {
        filterName() {
            const query = this.searchQuery.toLowerCase()
            if(this.searchQuery) {
               return this.adminList.filter((theUser) => {
                     return Object.values(theUser).some((word) => String(word).toLowerCase().includes(query))
                })
            }  else {
                return this.adminList
            }
        }
    },

    methods: {
        closeModal() {
            this.deleteModal = false;
        },
        toggleList(admin) {
            admin.navList = !admin.navList
        },
        next() {
            this.page++
            this.getAdmin()
        },

        moment(date) {
            return moment(date)
        },

        prev() {
            this.page--
            this.getAdmin()
        },


        getAdmin() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/users/admin?limit=20&page=${this.page}`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer ' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((res) => {
                this.adminList = res.data.data.results;
                this.currentList = this.adminList.length;
                this.totalList = res.data.data.meta.totalResults;
                               
            })
            .catch((err) => {
                this.error = err.response.data.message;
            }) ;
        },

        deleteAdminModal(admin) {
            this.adminId = admin._id;
            this.deleteModal = true;
            admin.navList = !admin.navList
            this.message =  "Are you sure you want to perform this action?"
        },
    }
}
</script>
<style scoped>
.pending {
    color: rgb(243, 243, 9);
}

.active{color: green;}

</style>